module.exports = __webpack_public_path__ + "fonts/Inter-800-greek74.eb1153e.woff2";